/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Invitation } from './Invitation';
import {
    InvitationFromJSON,
    InvitationFromJSONTyped,
    InvitationToJSON,
} from './Invitation';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';

/**
 * 
 * @export
 * @interface PageableInvitations
 */
export interface PageableInvitations {
    /**
     * 
     * @type {Array<Invitation>}
     * @memberof PageableInvitations
     */
    result: Array<Invitation>;
    /**
     * 
     * @type {Page}
     * @memberof PageableInvitations
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableInvitations interface.
 */
export function instanceOfPageableInvitations(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableInvitationsFromJSON(json: any): PageableInvitations {
    return PageableInvitationsFromJSONTyped(json, false);
}

export function PageableInvitationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableInvitations {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(InvitationFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableInvitationsToJSON(value?: PageableInvitations | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(InvitationToJSON)),
        'page': PageToJSON(value.page),
    };
}

